import React from 'react';
import { motion } from 'framer-motion';

const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen pt-24 pb-16 bg-background">
    <div className="container mx-auto px-4 max-w-4xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-8">{title}</h1>
        <div className="prose prose-emerald max-w-none bg-white rounded-2xl shadow-sm p-8 md:p-12 border border-muted">
          {children}
        </div>
      </motion.div>
    </div>
  </div>
);

export const PrivacyPolicy = () => (
  <LegalLayout title="Politika e Privatësisë">
    <div className="space-y-6 text-muted-foreground leading-relaxed">
      <section>
        <h2 className="text-xl font-bold text-foreground mb-4">1. Hyrje</h2>
        <p>
          Mirësevini në faqen zyrtare të Xhamisë së Ali Demit. Ne respektojmë privatësinë tuaj dhe jemi të përkushtuar për mbrojtjen e të dhënave tuaja personale.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-foreground mb-4">2. Të dhënat që mbledhim</h2>
        <p>
          Aplikacioni ynë nuk kërkon regjistrim për përdoruesit e thjeshtë. Ne mbledhim vetëm:
        </p>
        <ul className="list-disc pl-5 mt-2 space-y-2">
          <li>Të dhëna teknike (adresa IP, lloji i shfletuesit) për qëllime analitike.</li>
          <li>Tokenat e njoftimeve (nëse aktivizoni njoftimet Push) për t'ju mbajtur të informuar.</li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-bold text-foreground mb-4">3. Njoftimet Push</h2>
        <p>
          Për të dërguar njoftime rreth kohëve të namazit dhe lajmeve të xhamisë, ne përdorim shërbimin e njoftimeve të shfletuesit tuaj. Mund t'i çaktivizoni këto në çdo kohë nga cilësimet e aplikacionit ose shfletuesit.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-foreground mb-4">4. Siguria</h2>
        <p>
          Ne përdorim masa sigurie standarde për të mbrojtur serverat tanë dhe të dhënat tuaja.
        </p>
      </section>
    </div>
  </LegalLayout>
);

export const TermsOfService = () => (
  <LegalLayout title="Kushtet e Përdorimit">
    <div className="space-y-6 text-muted-foreground leading-relaxed">
      <section>
        <h2 className="text-xl font-bold text-foreground mb-4">1. Pranimi i Kushteve</h2>
        <p>
          Duke përdorur këtë aplikacion, ju pranoni kushtet e përshkruara këtu. Ky aplikacion ofrohet për informimin e komunitetit musliman.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-foreground mb-4">2. Përdorimi i Lejuar</h2>
        <p>
          Përdoruesit e faqes lejohen të shikojnë kohët e namazit, të lexojnë Kuranin, të shikojnë aktivitetet dhe të dëgjojnë ligjëratat. Çdo përdorim i paautorizuar i serverit apo ndërhyrje në kod është i ndaluar.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-foreground mb-4">3. Përgjegjësia</h2>
        <p>
          Xhamia e Ali Demit përpiqet të ofrojë informacion të saktë, por nuk mban përgjegjësi për gabime teknike eventuale apo vonesa në njoftime.
        </p>
      </section>
    </div>
  </LegalLayout>
);
